<template>
  <md-table id="validation-concepts-table" md-card>
    <md-table-row v-if="concepts.length">
      <md-table-head></md-table-head>
      <md-table-head>Cantidad Planeada</md-table-head>
      <md-table-head>Cantidad Real</md-table-head>
      <md-table-head>Concepto</md-table-head>
    </md-table-row>

    <template v-for="(concept, index) in concepts" v-if="concepts.length">
      <md-table-row :class="{}" :key="index">
        <md-table-cell>
          <div class="button-container">
            <template>
              <md-button
                class="md-round md-just-icon"
                @click="concept.showSupplies = !concept.showSupplies"
              >
                <md-icon>
                  {{
                  !concept.showSupplies ? "expand_more" : "expand_less"
                  }}
                </md-icon>
              </md-button>
            </template>
          </div>
        </md-table-cell>
        <md-table-cell md-label="Planeado">
          {{ concept.quantity }}
          {{ concept.unitMeasurement.abbr }}
        </md-table-cell>
        <md-table-cell md-label="Ejecutado">
          <md-field>
            <md-input
              v-model="concept.realQuantity"
              type="number"
              step="0.000001"
              :disabled="readOnly"
            ></md-input>
            <span class="md-suffix">{{ concept.unitMeasurement.abbr }}</span>
          </md-field>
        </md-table-cell>
        <md-table-cell md-label="Concepto" colspan="10">
          <p>
            <span class="md-body-2">{{ concept.name }}</span>
          </p>
          <p
            class="md-body-1"
            v-if="
              concept.description !== '' && concept.description !== concept.name
            "
          >
            <strong>Descripción</strong>
            {{ concept.description }}
          </p>
        </md-table-cell>
        <!--
          <md-table-cell md-label=" " >
            <md-button class="md-primary md-simple md-just-icon action-button"
              @click="$emit('clickedConcept', concept)"
            >
              <md-icon>cloud_upload</md-icon>
            </md-button>
          </md-table-cell>
        -->

        <!--<md-table-cell md-label="Acciones">-->
        <!--<md-button class="md-info md-simple md-just-icon" @click="removeConcept(concept)" v-if="!readOnly">-->
        <!--<md-icon>close</md-icon>-->
        <!--</md-button>-->
        <!--</md-table-cell>-->

        <md-tooltip
          v-if="concept.internal_concept || !concept.supplies.length"
        >{{ concept.internal_concept ? internalCon : emptyCon }}</md-tooltip>
      </md-table-row>

      <md-table-row class="concept-description" v-if="concept.showSupplies">
        <md-table-cell></md-table-cell>
        <md-table-cell colspan="7" v-if="concept.supplies.length">
          <md-content class="md-elevation-1">
            <concept-description :file-types="fileTypes" :concept="concept" />
          </md-content>
        </md-table-cell>
        <md-table-cell colspan="7" v-else>
          <loading-content
            class="md-accent"
            empty-icon="widgets"
            empty-label="No hay insumos"
            empty-description="El concepto no tiene insumos"
          />
        </md-table-cell>
      </md-table-row>
    </template>

    <loading-content
      empty-icon="category"
      empty-label="No hay conceptos"
      :empty-description="emptyDescription"
      v-if="!concepts.length"
    />
  </md-table>
</template>

<script>
import ConceptDescription from "./ConceptDescription";
import percentage from "@/filters/percentage";

const EMPTY_QUANTIFICATION_MSG = "No puede agregar nuevos conceptos.";

const ADD_CONCEPTS_MSG = "Agregue conceptos con el selector inferior.";

const INTERNAL_MSG =
  "Este concepto es interno, por lo tanto no aparecera en el Acta Entrega";

const EMPTY_CONCEPT_MSG =
  "El concepto no contiene insumos, porfavor agregue almenos uno";
import usesAccountInfoMixin from "@/mixins/usesAccountInfo";

import catalogService from "@/services/catalog";

const COPY_SUFFIX = "-CP";

export default {
  name: "ConceptsTable",

  mixins: [usesAccountInfoMixin],

  props: {
    concepts: {
      type: Array,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    selectionBlacklist: {
      type: Array,
      default: () => [],
    },
    conceptSelectionMode: {
      type: Boolean,
      default: true,
    },
    conceptsIssues: {
      type: Object,
      default: () => ({}),
    },
    showSupplyUsageHeader: Boolean,
    supplyUsageDisabled: Boolean,
    fileTypes: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    ConceptDescription,
  },

  filters: {
    percentage,
  },

  data() {
    return {
      COPY_SUFFIX,
      selectedConcepts: {},
      emptyCon: EMPTY_CONCEPT_MSG,
      internalCon: INTERNAL_MSG,
      currentSupplyCopy: null,
      nonUsedSupplies: [],
    };
  },

  computed: {
    total() {
      if (!this.concepts.length) {
        return 0;
      }
      return this.concepts
        .map((c) => c.unitPriceMXN * c.quantity)
        .reduce((a, b) => a + b);
    },

    suppliesTotal() {
      if (!this.concepts.length) {
        return 0;
      }
      return this.concepts.reduce((sum, concept) => {
        return concept.quantity * concept.suppliesSum + sum;
      }, 0);
    },

    directCost() {
      const { total, suppliesTotal } = this;
      return !!total ? (suppliesTotal * 100) / total : total;
    },

    emptyDescription() {
      return this.readOnly ? EMPTY_QUANTIFICATION_MSG : ADD_CONCEPTS_MSG;
    },
  },

  watch: {
    selectable(value) {
      if (!value) {
        for (const concept of this.concepts) {
          concept.selected = false;
          concept.showSupplies = false;

          for (const supply of concept.supplies) {
            supply.selected = false;
          }
        }
      } else {
        for (const concept of this.concepts) {
          concept.showSupplies = true;
        }
      }
    },
  },

  methods: {
    removeConcept(concept) {
      const index = this.concepts.indexOf(concept);
      this.concepts.splice(index, 1);
      this.$emit("removed", concept);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

.empty-concept {
  background: md-get-palette-color(red, 100);
}

.not-to-do-concept {
  background: md-get-palette-color(lime, 100) !important;
}

.internal-concept {
  background: md-get-palette-color(blue, 50);
}

#validation-concepts-table .md-table-cell:nth-child(2),
#validation-concepts-table .md-table-head:nth-child(2) {
  width: 20% !important;
}
.error-row p {
  padding: 10px 10px;
}

.error-row,
.error-row td.md-table-cell,
.error-row .md-card,
.error-row .md-card .md-card-content {
  height: auto;
  margin-top: 0px;
  padding-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.error-row .md-card,
.error-row .md-card .md-card-content {
  margin-left: 0px;
  padding-left: 0px;
}

.md-table-cell-container .md-button .md-button-content i.chat-respond {
  font-size: 20px !important;
}

@include md-register-theme(
  "success-card",
  (
    accent: md-get-palette-color(green, 500),
  )
);

.concept-description {
  background-color: #f9f9f9 !important;
}

.md-button.action-button .md-button-content i {
  font-size: 32px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/QuantitiesTable.vue